(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ---------- Tabs (index-based, fully scoped to the same wrapper) ----------
  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.collection-tabs__tab');
    if (!tab) return;

    // Find the wrapper that contains tabs + panels for THIS instance only
    // Your structure has .padding-right around both; fallback to a higher wrapper if needed.
    const wrap = tab.closest('.padding-right') || tab.closest('.collection-tabs-section');
    if (!wrap) return;

    const tabs   = Array.from(wrap.querySelectorAll('.collection-tabs__tab'));
    const panels = Array.from(wrap.querySelectorAll('.collection-tabs__products'));
    const idx    = tabs.indexOf(tab);
    if (idx < 0 || !panels[idx]) return;

    // Deactivate only inside this wrapper
    tabs.forEach(t => { t.classList.remove('active'); t.setAttribute?.('aria-selected','false'); });
    panels.forEach(p => { p.classList.remove('active'); p.setAttribute?.('aria-hidden','true'); });

    // Activate the clicked tab + corresponding panel (by index)
    tab.classList.add('active');
    tab.setAttribute?.('aria-selected','true');
    panels[idx].classList.add('active');
    panels[idx].setAttribute?.('aria-hidden','false');

    // Refresh arrows for any carousel inside the now-visible panel
    panels[idx].querySelectorAll('.carousel-container').forEach(updateArrowState);
  });

  // Keyboard support
  document.addEventListener('keydown', function (e) {
    const tab = e.target.closest('.collection-tabs__tab');
    if (!tab) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tab.click(); }
  });

  // ---------- Carousel controls (scoped via closest container) ----------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.carousel-button');
    if (!btn) return;

    const carousel = btn.closest('.carousel-container');
    if (!carousel) return;

    const track = carousel.querySelector('.carousel-track');
    if (!track) return;

    const slide = track.querySelector('.carousel-slide');
    const slideWidth = slide ? slide.offsetWidth : 300;

    const styles = getComputedStyle(track);
    const gap = parseInt(styles.columnGap || styles.gap || '20', 10) || 20;

    const visibleCount = Math.max(1, Math.round(track.clientWidth / (slideWidth + gap)));
    const scrollAmount = visibleCount * (slideWidth + gap);
    const dir = btn.classList.contains('prev') ? -1 : 1;

    track.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
  });

  // ---------- Arrow state helpers ----------
  function updateArrowState(carousel) {
    const track   = carousel.querySelector('.carousel-track');
    const leftBtn = carousel.querySelector('.carousel-button.prev');
    const rightBtn= carousel.querySelector('.carousel-button.next');
    if (!track || !leftBtn || !rightBtn) return;

    const scrollLeft   = track.scrollLeft;
    const maxScrollLeft= track.scrollWidth - track.clientWidth;

    if (scrollLeft <= 10) {
      leftBtn.style.color = '#ccc'; rightBtn.style.color = '#000';
    } else if (scrollLeft >= maxScrollLeft - 10) {
      rightBtn.style.color = '#ccc'; leftBtn.style.color = '#000';
    } else {
      leftBtn.style.color = '#000'; rightBtn.style.color = '#000';
    }
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('.carousel-container').forEach(carousel => {
      const track = carousel.querySelector('.carousel-track');
      if (!track) return;
      const onChange = () => updateArrowState(carousel);
      track.addEventListener('scroll', onChange);
      window.addEventListener('resize', onChange);
      updateArrowState(carousel);
    });
  }

  function initSection(scope) { initCarousels(scope); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSection(document); });
  } else {
    initSection(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
